import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-425feee4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "circular-border" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Digite aqui", -1))
const _hoisted_3 = {
  key: 0,
  class: "coupons-skeleton"
}
const _hoisted_4 = { class: "coupon-name" }
const _hoisted_5 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_basic_header = _resolveComponent("basic-header")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_skeleton_text = _resolveComponent("ion-skeleton-text")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_radio = _resolveComponent("ion-radio")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_radio_group = _resolveComponent("ion-radio-group")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createBlock(_component_ion_content, null, {
    default: _withCtx(() => [
      _createVNode(_component_basic_header, { title: "Cupons" }),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_ion_card, { class: "write-code" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_card_header, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_card_subtitle, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Tem um código de cupom? "),
                    _hoisted_2
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_card_content, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_item, { class: "no-padding" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_input, {
                      modelValue: _ctx.couponName,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.couponName) = $event)),
                      placeholder: "Código",
                      autocomplete: "off",
                      onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.confirmValidateCoupon(_ctx.couponName)), ["enter"]))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ion_button, {
                      class: "btn-active",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.confirmValidateCoupon(_ctx.couponName)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Ativar")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.loadingRef)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (i) => {
                return _createVNode(_component_ion_card, { key: i }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_header, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_skeleton_text, { animated: "" })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_card_content, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_skeleton_text, { animated: "" }),
                        _createVNode(_component_ion_skeleton_text, { animated: "" }),
                        _createVNode(_component_ion_skeleton_text, { animated: "" })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1024)
              }), 64))
            ]))
          : (_openBlock(), _createBlock(_component_ion_radio_group, {
              key: 1,
              class: "coupon-selection",
              value: _ctx.ticketApplied
            }, {
              default: _withCtx(() => [
                (_ctx.couponsAvailableRef.length == 0)
                  ? (_openBlock(), _createBlock(_component_ion_card, {
                      key: 0,
                      class: "without-coupon-available"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_content, { class: "no-coupon" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Nenhum cupom disponível aqui.")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.couponsAvailableRef, (coupon) => {
                  return (_openBlock(), _createBlock(_component_ion_card, {
                    key: coupon.id,
                    onClick: ($event: any) => (_ctx.confirmValidateCoupon(coupon.name))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_header, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_4, [
                            _createVNode(_component_ion_icon, { icon: _ctx.ticketOutline }, null, 8, ["icon"]),
                            _createTextVNode(" " + _toDisplayString(coupon.description), 1)
                          ]),
                          _createVNode(_component_ion_radio, {
                            mode: "md",
                            value: coupon.name
                          }, null, 8, ["value"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_card_content, { class: "card-content" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            class: "full-rule",
                            innerHTML: coupon.rules
                          }, null, 8, _hoisted_5)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_label, { class: "card-footer" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Valido até " + _toDisplayString(_ctx.dateToBr(coupon.valid_until)), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value"]))
      ])
    ]),
    _: 1
  }))
}